import Cookies from 'universal-cookie';
import isBrowser from 'is-in-browser';

import { stores } from '../chore/configureStore';
import { updateSessionTimeout } from '../session/sessionActions';

import { getContext } from '@requestContext';

export function init(serverCookie) {
  if (serverCookie) {
    return new Cookies(serverCookie);
  } else {
    return new Cookies();
  }
}

/* Set an Array with the SessionId and a timestamp. The timestamp is used to prevent Admin Idle disconnection while using multiple windows. */
export function saveSessionId(sessionId) {
  let cookies = null;
  if(isBrowser)
    cookies = new Cookies();
  else {
    let ctx = getContext();
    if(ctx)
      cookies = ctx.cookies;
  }

  if(!cookies)
    return;

  cookies.set('session-id', sessionId, { path: '/', maxAge: 1800, secure: !LOCAL }); // 1800 = 30min
  // // Save cookie set date in the store.
  // if(isBrowser) stores[0].dispatch(updateSessionTimeout());
}

export function readSessionId() {
  let cookies = null;
  if(isBrowser)
    cookies = new Cookies();
  else {
    let ctx = getContext();
    if(ctx)
      cookies = ctx.cookies;
  }

  if(!cookies)
    return null;

  return cookies.get('session-id');
}

export function clearSessionId() {
  let cookies = null;
  if(isBrowser)
    cookies = new Cookies();
  else {
    let ctx = getContext();
    if(ctx)
      cookies = ctx.cookies;
  }

  if(!cookies)
    return;

  return cookies.remove('session-id', { path: '/' });
}

export function saveSessionDate() {
  let cookies = null;
  if(isBrowser)
    cookies = new Cookies();
  else {
    let ctx = getContext();
    if(ctx)
      cookies = ctx.cookies;
  }

  if(!cookies)
    return;

  cookies.set('session-date', Date.now(), { path: '/', maxAge: 1800, secure: !LOCAL }); // 1800 = 30min
  // Save cookie set date in the store.
  if(isBrowser) stores[0].dispatch(updateSessionTimeout());
}

export function readSessionDate() {
  let cookies = null;
  if(isBrowser) {
    cookies = new Cookies();
  }
  else {
    let ctx = getContext();
    if(ctx)
      cookies = ctx.cookies;
  }

  if(!cookies)
    return null;

  return cookies.get('session-date');
}

export function clearSessionDate() {
  let cookies = null;
  if(isBrowser)
    cookies = new Cookies();
  else {
    let ctx = getContext();
    if(ctx)
      cookies = ctx.cookies;
  }

  if(!cookies)
    return;

  return cookies.remove('session-date', { path: '/' });
}

export function saveResentActivationEmail() {
  let cookies = null;
  if(isBrowser)
    cookies = new Cookies();
  else {
    let ctx = getContext();
    if(ctx)
      cookies = ctx.cookies;
  }

  if(!cookies)
    return;

  cookies.set('hasResentActivationEmail', true, { path: '/', maxAge: 43200, secure: !LOCAL }) // 43200 = 24h
}

export function readResentActivationEmail() {
  let cookies = null;
  if(isBrowser)
    cookies = new Cookies();
  else {
    let ctx = getContext();
    if(ctx)
      cookies = ctx.cookies;
  }

  if(!cookies)
    return null;

  return cookies.get('hasResentActivationEmail')
}

export function clearResentActivationEmail() {
  let cookies = null;
  if(isBrowser)
    cookies = new Cookies();
  else {
    let ctx = getContext();
    if(ctx)
      cookies = ctx.cookies;
  }

  if(!cookies)
    return;

  return cookies.remove('hasResentActivationEmail', { path: '/' })
}

export function saveTwitchConnectCode(code) {
  let cookies = null;
  if(isBrowser)
    cookies = new Cookies();
  else {
    let ctx = getContext();
    if(ctx)
      cookies = ctx.cookies;
  }

  if(!cookies)
    return;

  cookies.set('twitchConnectCode', code, { path: '/', maxAge: 1800, secure: !LOCAL }) // 1800 = 1h
}

export function readTwitchConnectCode() {
  let cookies = null;
  if(isBrowser)
    cookies = new Cookies();
  else {
    let ctx = getContext();
    if(ctx)
      cookies = ctx.cookies;
  }

  if(!cookies)
    return null;

  return cookies.get('twitchConnectCode')
}

export function clearTwitchConnectCode() {
  let cookies = null;
  if(isBrowser)
    cookies = new Cookies();
  else {
    let ctx = getContext();
    if(ctx)
      cookies = ctx.cookies;
  }

  if(!cookies)
    return;

  return cookies.remove('twitchConnectCode', { path: '/' })
}
